import CacheService from 'app/services/cacheService';
import { actionTypes } from 'app/store/reducers/cacheReducer';
import useAxios from 'axios-hooks';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

const useAxiosGet = (config, options) => {
  const cache = useSelector(({ cache }) => cache);
  const [cacheData, setCacheData] = useState();
  const [{ data, error, ...other }, fetch] = useAxios(
    typeof config === 'string'
      ? {
          url: config,
          method: 'GET'
        }
      : {
          ...config,
          method: 'GET'
        },
    {
      ...options,
      manual: true,
      ignoreCache: true
    }
  );
  const dispatch = useDispatch();
  const navigate = useNavigate();

  // Redirect if errors
  useEffect(() => {
    if (error?.response?.status === 403) {
      navigate('/error-403');
    }
    if (error?.response?.status === 404) {
      navigate('/error-404');
    }
  }, [error, navigate]);

  useEffect(() => {
    if (!options?.manual && !options?.ignoreCache && config) {
      const newCacheData = CacheService.getDataFromConfig(cache.cache, config);

      if (newCacheData) {
        setCacheData([...newCacheData]);
      } else {
        fetch(config, options).then(res => {
          dispatch({
            type: actionTypes.add,
            payload: {
              keys: [CacheService.createCacheKey(config, 'GET')],
              data: res.data
            }
          });
        });
      }
    } else if (!options?.manual) {
      fetch(config, options);
    }
  }, [cache, config]);

  return [
    {
      data: !options?.ignoreCache ? cacheData : data,
      ...other
    },
    fetch
  ];
};

export default useAxiosGet;
